import {NewsEvent} from "../stores/events";
import RandomGenerator from "./RandomGenerator";

export default class EventGenerator {

    private readonly generator: RandomGenerator;
    private readonly events: NewsEvent[];

    constructor(seed: string, events: NewsEvent[]) {
        this.generator = new RandomGenerator(seed);
        this.events = this.shuffle(events);
    }

    private shuffle(array: any[]) {

        let currentIndex = array.length;

        while (currentIndex !== 0) {
            const randomIndex = Math.floor(this.generator.next() * currentIndex);
            currentIndex--;
            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }

        return array;

    }

    public nextOrNull(): NewsEvent|null {

        const probability = 0.025;
        if (this.generator.next() < probability && this.events.length > 0) {
            return this.events.pop() || null;
        }
        return null;

    }

}